import axios from 'axios';
import API from '../endpoints';
import { useQuery } from '@tanstack/react-query';
import { Team } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for team detail query
const CACHE_TIME = 30 * 60 * 1000;

export const useTeamBySlugQuery = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['team', { slug: slug! }],
    queryFn: async () => {
      const { data } = await axios.get<Team | null>(`${API.endpoints.teams}/${slug}`);
      return data;
    },
    enabled: !!slug,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

export const fetchTeamBySlug = async (slug: string): Promise<Team | null> => {
  const { data } = await axios.get<Team | null>(`${API.endpoints.teams}/${slug}`);
  return data;
};
